import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["modal", "form", "programName", "statusRadio"];
  static values = {
    baseUrl: String
  };

  connect() {
    if (this.hasModalTarget) {
      this.modalTarget.addEventListener('hidden.bs.modal', this._handleModalHidden.bind(this));
    }
  }

  disconnect() {
    if (this.hasModalTarget) {
      this.modalTarget.removeEventListener('hidden.bs.modal', this._handleModalHidden.bind(this));
    }
  }

  open(event) {
    event.preventDefault();

    const programId = event.currentTarget.dataset.programId;
    const programName = event.currentTarget.dataset.programName;
    const currentStatus = event.currentTarget.dataset.currentStatus;

    const formUrl = this.baseUrlValue.replace(':id', programId);
    this.formTarget.action = formUrl;

    this.programNameTarget.textContent = programName;

    this.statusRadioTargets.forEach(radio => {
      radio.checked = radio.value === currentStatus;
    });

    const modal = new Modal(this.modalTarget);
    modal.show();
  }

  _handleModalHidden() {
    this.statusRadioTargets.forEach(radio => {
      radio.checked = false;
    });
  }
}
